import {
  $jinglesTableSearchInputValue,
  JinglesTable,
  JinglesTableGate,
  jinglesTableQuery,
} from '@/entities/tracks'
import { STRINGS } from '@/shared/config'
import { EmptyContent, HidingSpin } from '@/shared/ui'
import { jingleFormModalOpened } from '@/widgets/JingleForm'
import { Button, Space } from 'antd'
import { useUnit } from 'effector-react'

import {
  $jinglesListPageLatestJinglesFilters,
  $jinglesListPageLatestJinglesPage,
  $jinglesListPageLatestJinglesPageSize,
  $jinglesListPageLatestJinglesSearch,
  $jinglesListPageLatestJinglesSort,
  JinglesListPageJinglesGate,
} from '../../../model/jingles-list-jingles-tab.model'

export const JinglesTab = () => {
  const { data, pending, error } = useUnit(jinglesTableQuery)

  const search = useUnit($jinglesTableSearchInputValue)
  const latestSearch = useUnit($jinglesListPageLatestJinglesSearch)
  const latestSort = useUnit($jinglesListPageLatestJinglesSort)
  const latestFilters = useUnit($jinglesListPageLatestJinglesFilters)
  const latestPage = useUnit($jinglesListPageLatestJinglesPage)
  const latestPageSize = useUnit($jinglesListPageLatestJinglesPageSize)

  const openJingleFormModal = useUnit(jingleFormModalOpened)
  return (
    <>
      <JinglesListPageJinglesGate />
      <JinglesTableGate
        initialFilters={latestFilters}
        initialPage={latestPage}
        initialPageSize={latestPageSize}
        initialSort={latestSort}
        initialSearch={latestSearch}
      />
      <HidingSpin spinning={pending || (!data?.items && !error)}>
        {data?.items && data.items.length > 0 ? (
          <JinglesTable
            onEdit={(jingleId: string) => {
              openJingleFormModal({ id: jingleId })
            }}
          />
        ) : search?.length && search?.length > 0 ? (
          <EmptyContent description={STRINGS.nothing_was_found} />
        ) : (
          <EmptyContent
            description="В списке пока нет ни одного джингла"
            content={
              <Space>
                <Button
                  onClick={() => {
                    openJingleFormModal()
                  }}
                >
                  Добавить новый джингл
                </Button>
              </Space>
            }
          />
        )}
      </HidingSpin>
    </>
  )
}
